"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADDON_PARAM = exports.ADDON_ID = void 0;
var ADDON_ID = 'addon-toolbars';
exports.ADDON_ID = ADDON_ID;
var ADDON_PARAM = 'toolbars';
exports.ADDON_PARAM = ADDON_PARAM;